import { ACL_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  SpacePutBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  spaceId: string
  params: SpacePutBody[]
  children?: (response: SpacePutBody) => ReactElement
  onSuccess?: (response: SpacePutBody) => void
  onError?: (error: Error) => void
}

const SaveSpaceMembersRequest = ({
  spaceId,
  params,
  children,
  onSuccess,
  onError
}: Props) => {
  const queryParams = '?principal_types=user&principal_types=group' // backend require this format but object cannot have duplicate keys name
  const url = `${ACL_SERVICE}/acls/space/${spaceId}${queryParams}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default SaveSpaceMembersRequest
